export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M4.287 4.295a.75.75 0 0 1 1.06 0l7.183 7.182.052.057a.75.75 0 0 1-.052 1.004L5.348 19.72a.75.75 0 0 1-1.06-1.06l6.652-6.654-6.653-6.652a.75.75 0 0 1 0-1.06Zm7.19 0a.75.75 0 0 1 1.06 0l7.184 7.182.05.057a.75.75 0 0 1-.05 1.004l-7.184 7.183a.75.75 0 0 1-1.06-1.06l6.652-6.654-6.652-6.652a.75.75 0 0 1 0-1.06Z"/>
</svg>
`;
